<template>
  <div class="rfq-wrapper zhenyun-theme">
    <div class="breadcrumb-box">
      <a
        class="breadcrumb1"
        @click="$router.push({ path: '/partner/quote' })"
      >我的报价</a>
      <span class="separator"> > </span>
      <span class="breadcrumb2"> 报价详情 </span>
    </div>
    <div class="rfq-card" v-loading="fullPageLoading">
      <div class="rfq-card-header">
        <div class="left">
          <span>报价编号：{{ detailInfo.id }}</span>
          <span
            >询盘编号：<span
              class="mock-a"
              @click="handleGpRefDetail(detailInfo)"
            >
              RFQ#{{ detailInfo.rfqId }}
            </span></span
          >
          <span>询盘来源：{{ detailInfo.rfqSourceStr }}</span>
        </div>
        <div class="right"></div>
      </div>
      <!-- 甄云状态 -->
      <quoteStatus
        v-if="detailInfo.rfqSource=='20'"
        :status="detailInfo.status"
        :detailInfo="detailInfo"
        @updateQuoteStatus="updateQuoteStatus"
        @handleSubmit="handleSubmitQuote"
      ></quoteStatus>
      <!-- 非甄云状态 -->
      <otherChannelStatus
        v-else
        :status="detailInfo.status"
        :detailInfo="detailInfo"
        @updateQuoteStatus="updateQuoteStatus"
        @handleSubmit="handleSubmitQuote"
      ></otherChannelStatus>
      <div class="padding16">
        <quoteGridDescriptions
          title="采购商信息"
          :sourceData="procurerData"
          :column="1"
        >
          <template #compInfo="{ item }">
            <p class="description-value" v-if="item && item.value">
              <span v-if="item.value.aesCompId">
                {{ address1(item.value) }}
                <span>&nbsp;{{ item.value.postCode }}</span>
              </span>
              <span v-else> -- </span>
            </p>
            <span class="description-value" v-else>
              {{ '--' }}
            </span>
          </template>
        </quoteGridDescriptions>
      </div>
      <div class="padding16">
        <quoteGridDescriptions
          title="报价单信息"
          :sourceData="quoteData"
          :column="2"
        >
          <template #submitTime="{ item }">
            <span class="description-value" v-if="item && item.value">
              {{
                !item.value || item.value == '--'
                  ? '--'
                  : moment(item.value).format('YYYY-MM-DD HH:mm:ss')
              }}
            </span>
          </template>
          <template #validDate="{ item }">
            <p class="description-value" v-if="item && item.value">
              <span v-if="!isExpired(item.value)">{{
                moment(item.value).format('YYYY-MM-DD')
              }}</span>
              <span v-else style="color: #ff081f"
                >{{ moment(item.value).format('YYYY-MM-DD') }}（已过期）</span
              >
            </p>
          </template>
          <template #freightAddrVo="{ item }">
            <p class="description-value" v-if="item && item.value">
              <span v-if="item.value.id"
                >{{ address(item.value) }}&nbsp;{{ item.value.postCode }}</span
              >
              <span v-else>--</span>
            </p>
            <span class="description-value" v-else>
              {{ '--' }}
            </span>
          </template>
          <template #remark="{item}">
            <span class="description-value" v-html="formatText(item.value)"></span>
          </template>
          <template #attachments="{ item }">
            <div class="file-list-show-box" v-if="item.value?.length > 0">
              <p
                class="file-item"
                style="color: #0863ff; font-size: 14px"
                v-for="(fileItem, fileIndex) in item.value"
                :key="fileIndex"
              >
                <i class="iconfont icon-attach" style="margin-right: 4px"></i>
                <a @click="handleDowload(fileItem)">{{ fileItem.name }}</a>
              </p>
            </div>
            <span class="description-value" v-else>
              {{ '--' }}
            </span>
          </template>
        </quoteGridDescriptions>
      </div>
      <div class="rfq-card-content">
        <partTableInfo
          :part-info-list="detailInfo.parts"
          :detail-info="detailInfo"
          ref="partTableInfoRef"
          :isEdit="false"
        ></partTableInfo>
      </div>
      <historyQuote
        v-if="historyData.length > 0 && detailInfo.status != 1"
        ref="historyQuoteRef"
        :historyData="historyData"
        @changeShowStatus="changeShowStatus"
      ></historyQuote>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import partTableInfo from './components/part-table-info.vue'
import quoteStatus from './components/quote-status.vue'
import otherChannelStatus from './components/other-channel-status.vue'
import quoteGridDescriptions from './components/quote-grid-descriptions.vue'
import { getMyQuoteDetailApi, saveQuoteOrderApi } from '@/utils/api/zhenyun.js'
import historyQuote from './components/history-quote.vue'
import moment from 'moment'
import { fileUrl, onlineUrl, companyLogoUrl } from '@/utils/config.js'
export default {
  props: [],
  data() {
    return {
      fullPageLoading: false,
      historyData: [],
      procurerData: [
        {
          name: '公司名称',
          label: 'cnName',
          value: '--',
        },
        {
          name: '地址',
          label: 'address',
          value: '--',
        },
      ],
      quoteData: [
        {
          name: '报价时间',
          label: 'submitTime',
          value: '',
        },
        {
          name: '支付条款',
          label: 'paymentTerms',
          value: '',
        },
        {
          name: '报价有效期',
          label: 'validDate',
          value: '',
        },
        {
          name: '货运条款',
          label: 'shippingTermsStr',
          value: '',
        },
        {
          name: '报价货币',
          label: 'currency',
          value: '',
        },
        {
          name: '交货地点',
          label: 'freightAddrVo',
          value: '',
        },
        {
          name: '报价说明',
          label: 'remark',
          value: '',
        },
        {
          name: '报价附件',
          label: 'attachments',
          value: '',
        },
      ],
      detailInfo: {},
    }
  },
  components: {
    partTableInfo,
    quoteStatus,
    quoteGridDescriptions,
    historyQuote,
    otherChannelStatus,
  },
  methods: {
    moment,
    ...mapActions('zhenyunStore', ['getZhenyunLevelLength']),
    address1(address) {
      const { state, province, city } = address
      return [state, province, city].filter(Boolean).join('，')
    },
    formatText(text) {
      return text.replace(/\n/g, '<br>')
    },
    handleDowload(item) {
      const a = document.createElement('a')
      a.href = `${onlineUrl}${item.url}`
      a.target = '_blank'
      a.download = item.name || 'download' // 设置下载文件名
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    address(freightAddrVo) {
      const { stateIdStr, provinceIdStr, cityIdStr,cityId } = freightAddrVo
      return  [stateIdStr, provinceIdStr, !cityId ? undefined : cityIdStr].filter(Boolean).join('，')
    },
    isExpired(targetDate) {
      const todayStart = moment().startOf('day')
      const targetMoment = moment(targetDate).startOf('day')
      return targetMoment.isBefore(todayStart) // 目标日期是否早于今天
    },
    handleGpRefDetail(item) {
      this.$router.push({
        name: 'order-radar-detail',
        params: {
          id: item.rfqId,
        },
        query: {
          quoteId: item.id,
        },
      })
    },
    changeShowStatus({ item, index }) {
      this.historyData[index].isShowInfo = !this.historyData[index].isShowInfo
    },
    async fetchInfo() {
      try {
        this.fullPageLoading = true
        const res = await getMyQuoteDetailApi({
          rfqQuoteId: this.$route.params.id,
        })
        this.fullPageLoading = false
        const { rspResult, data } = res
        if (rspResult.bizCode == 200) {
          this.detailInfo = data
          this.detailInfo.symbol = data.currencySymbol
          this.historyData = (data.historyQuoteInfo || []).map((k) => {
            k.isShowInfo = false
            k.attachList = (k.attachments || []).map((file) => {
              file.name = file.originalName
              return file
            })
            return k
          })
          this.detailInfo.attachList = (this.detailInfo.attachments || []).map(
            (k) => {
              k.name = k.originalName
              return k
            }
          )
          this.procurerData = [
            {
              name: '公司名称',
              label: 'cnName',
              value: data.compInfo.cnName || '--',
            },
            {
              name: '地址',
              label: 'compInfo',
              value: data.compInfo,
            },
          ]
          const infoMap = new Map(Object.entries(data))
          for (let item of this.quoteData) {
            if (infoMap.has(item.label)) {
              const val = infoMap.get(item.label)
              item.value = !val ? '--' : val
            }
          }
          this.detailInfo.parts = (data.partsInfos || []).map((k) => {
            const quantityFields = ['quoteNum1', 'quoteNum2', 'quoteNum3']
            const existingQuantityFields = quantityFields.filter(
              (field) => k[field]
            )
            const quoteLength = Array.from(
              { length: existingQuantityFields.length },
              (_, index) => index + 1
            )
            return {
              ...k,
              partPriceInfoList: quoteLength.map((l) => {
                return {
                  numQuantity: k[`quoteNum${l}`],
                  ...k.quotePrice.reduce((acc, cur, index, thisArr) => {
                    if (1 <= cur.itemType <= 4) {
                      acc[`num${cur.itemType}`] = thisArr[index][`value${l}`]
                    }
                    return acc
                  }, {}),
                }
              }),
            }
          })
          this.$nextTick(() => {
            this.$refs.partTableInfoRef.initFormData(
              this.detailInfo.parts || []
            )
          })
        }
      } catch (error) {
        this.fullPageLoading = false
      }
    },
    updateQuoteStatus() {
      this.fetchInfo()
    },
    initSubmitParams(status, sourceInfoData) {
      const copyObj = JSON.parse(JSON.stringify(sourceInfoData))
      copyObj.parts = undefined
      copyObj.status = status
      copyObj.acceptPaymentTerm = sourceInfoData.acceptPaymentTerm ? 1 : 0
      copyObj.validDate = new Date(sourceInfoData.validDate).valueOf()
      copyObj.rfqQuoteId = sourceInfoData.id
      copyObj.rfqId ||= this.$route.params.id
      const initPartParams = sourceInfoData.parts.reduce((result, part) => {
        const transformedItem = {
          itemList: [1, 2, 3, 4, 5].map((type) => {
            const valueKey = type === 5 ? 'partRowTotalNumber' : `num${type}`
            const priceItem = part.quotePrice.find(
              (item) => item.itemType === type
            )
            return {
              type,
              ...part.partPriceInfoList.reduce((acc, priceInfo, idx) => {
                acc[`num${idx + 1}`] = priceInfo[valueKey]
                return acc
              }, {}),
              id: priceItem ? priceItem.quoteItemId : null,
            }
          }),
          rfqPartId: part.id || part.rfqPartId,
        }
        result.push(transformedItem)
        return result
      }, [])
      // 在这里整理参数，把多余的参数去掉，只留下必须的参数
      const initPayloadParams = {
        acceptPaymentTerm: copyObj.acceptPaymentTerm,
        validDate: copyObj.validDate,
        paymentTerm: copyObj.paymentTerm,
        remark: copyObj.remark,
        attachList: copyObj.attachList.map((k) => k.hashCode),
        partsList: initPartParams,
        rfqId: copyObj.rfqId,
        status: copyObj.status,
        rfqQuoteId: copyObj.rfqQuoteId,
        status: copyObj.status,
        shippingMethod: copyObj.shippingMethod,
        shippingTerms: copyObj.shippingTerms,
        paymentOwn: copyObj.paymentOwn,
      }
      return initPayloadParams
      // return copyObj
    },
    handleSubmitQuote() {
      const params = this.initSubmitParams('2', this.detailInfo)
      this.submitQuote(params)
    },
    async submitQuote(params) {
      try {
        this.fullPageLoading = true
        const res = await saveQuoteOrderApi(params)
        const { rspResult, data } = res
        if (rspResult.bizCode == 5005) {
          this.$message.error('已失效的报价单不能提交')
        } else if (rspResult.bizCode == 5006) {
          this.$message.error('报价已结束')
        } else if (rspResult.bizCode == 200) {
          this.$message.success('提交成功')
          await this.getZhenyunLevelLength()
          this.fetchInfo()
        } else {
          this.$message.error(rspResult.message)
        }
        this.fullPageLoading = false
      } catch (error) {
        this.fullPageLoading = false
      }
    },
  },
  mounted() {
    this.fetchInfo()
  },
}
</script>

<style scoped lang="scss">
.rfq-wrapper {
  width: 1200px;
  margin: 0 auto;
  .breadcrumb-box {
    padding: 16px 0;
    .breadcrumb1,
    .separator {
      color: #98a3b7;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      cursor: pointer;
    }
    .breadcrumb2 {
      color: #333333;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      cursor: pointer;
    }
    .separator {
      margin: 0 4px;
    }
  }
  .rfq-card {
    width: 100%;
    background-color: #fff;
    padding-bottom: 16px;
    margin-bottom: 16px;
    .rfq-card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 0;
      margin: 0 16px;
      border-bottom: 1px solid #e9edf1;

      .left,
      .right {
        display: flex;
        align-items: center;
      }
      .left {
        display: flex;
        align-items: center;
        gap: 24px;
        span {
          color: #333333;
          font-family: SourceHanSansCN-Regular;
          font-size: 14px;
          line-height: 22px;
        }
      }
    }

    .rfq-card-content {
      margin: 0 16px 0;
      border: 1px solid #e9edf1;
    }
  }
}
.padding16 {
  padding: 16px;
}
.description-value {
  flex: 1 0 0;
  color: #333333;
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  line-height: 22px;
}
.mock-a {
  cursor: pointer;
}
.mock-a:hover {
  color: #0863ff !important;
}
.file-list-show-box {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
</style>
